import type { ReleaseNote } from '@/api/releaseApproval';

/** Release notes as the page lists them: new, improved, fixed (#3316). */
export function groupChanges(entries: readonly ReleaseNote[]): Record<ReleaseNote['category'], ReleaseNote[]> {
  const groups: Record<ReleaseNote['category'], ReleaseNote[]> = { new: [], improved: [], fixed: [] };
  for (const entry of entries) groups[entry.category].push(entry);
  return groups;
}
